"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUBILiquidity = exports.getPACTTVL = exports.hasPACTVotingPower = exports.getPACTTradingMetrics = exports.circulatingSupply = void 0;
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const bignumber_js_1 = require("bignumber.js");
const contracts_1 = require("@ethersproject/contracts");
const contractAddress_1 = require("./contractAddress");
const contracts_2 = require("./contracts");
const toNumber_1 = require("./toNumber");
const BaseERC20_json_1 = tslib_1.__importDefault(require("./abi/BaseERC20.json"));
const axios_1 = tslib_1.__importDefault(require("axios"));
const client = new client_1.ApolloClient({
    cache: new client_1.InMemoryCache(),
    uri: 'https://api.thegraph.com/subgraphs/name/ubeswap/ubeswap'
});
async function circulatingSupply(provider, chainId) {
    const contractAddresses = contractAddress_1.ContractAddresses.get(chainId);
    const { PACTDelegator, PACTToken, DonationMiner, MerkleDistributor, ImpactLabs, IDO } = contractAddresses;
    const decimals = new bignumber_js_1.BigNumber(10).pow(18);
    const pact = new contracts_1.Contract(PACTToken, BaseERC20_json_1.default, provider);
    const airgrabPACTBalance = await pact.balanceOf(MerkleDistributor);
    const daoPACTBalance = await pact.balanceOf(PACTDelegator);
    const donationMinerPACTBalance = await pact.balanceOf(DonationMiner);
    const impactLabsPACTBalance = await pact.balanceOf(ImpactLabs);
    const idoPACTBalance = await pact.balanceOf(IDO);
    // 10B
    const totalSupply = new bignumber_js_1.BigNumber(10000000000).multipliedBy(decimals);
    const circulatingSupply = new bignumber_js_1.BigNumber(totalSupply)
        .minus(airgrabPACTBalance.toString())
        .minus(daoPACTBalance.toString())
        .minus(donationMinerPACTBalance.toString())
        .minus(impactLabsPACTBalance.toString())
        .minus(idoPACTBalance.toString());
    return circulatingSupply.dividedBy(decimals).toNumber();
}
exports.circulatingSupply = circulatingSupply;
async function getPACTTradingMetrics(chainId) {
    // if not on mainnet
    if (chainId !== 42220) {
        return {
            dailyVolumeUSD: '0',
            priceUSD: '0',
            tokenHolders: 0,
            totalLiquidityUSD: '0',
            transfers: 0
        };
    }
    const contractAddresses = contractAddress_1.ContractAddresses.get(chainId);
    const { PACTToken } = contractAddresses;
    let statsFromUbeswapSubgraph = {
        dailyVolumeUSD: '--',
        priceUSD: '--',
        totalLiquidityUSD: '--'
    };
    try {
        const result = await client.query({
            query: (0, client_1.gql) `
                {
                    tokenDayDatas(
                        first:1
                        orderBy: date
                        orderDirection: desc
                        where: {token: "${PACTToken.toLowerCase()}"}
                    ) {
                        priceUSD
                        dailyVolumeUSD
                        totalLiquidityUSD
                    }
                }
                `
        });
        statsFromUbeswapSubgraph = result.data.tokenDayDatas[0];
    }
    catch (_) { }
    let counters = { data: { token_holder_count: 0, transfer_count: 0 } };
    try {
        counters = await axios_1.default.get(`https://explorer.celo.org/${chainId === 42220 ? 'mainnet' : 'alfajores'}/token-counters?id=${PACTToken}`);
    }
    catch (_) { }
    return Object.assign(Object.assign({}, statsFromUbeswapSubgraph), { tokenHolders: counters.data.token_holder_count, transfers: counters.data.transfer_count });
}
exports.getPACTTradingMetrics = getPACTTradingMetrics;
async function hasPACTVotingPower(provider, chainId, address) {
    const { pact: pactContract, delegate } = (0, contracts_2.getContracts)(provider, chainId);
    if (address === null ||
        !(delegate === null || delegate === void 0 ? void 0 : delegate.address) ||
        !(delegate === null || delegate === void 0 ? void 0 : delegate.provider) ||
        !(pactContract === null || pactContract === void 0 ? void 0 : pactContract.address) ||
        !(pactContract === null || pactContract === void 0 ? void 0 : pactContract.provider)) {
        return;
    }
    try {
        const [proposalThreshold, currentVotes] = await Promise.all([
            delegate.proposalThreshold(),
            pactContract.getCurrentVotes(address)
        ]);
        return new bignumber_js_1.BigNumber(currentVotes.toString()).gte(proposalThreshold.toString());
    }
    catch (error) {
        console.log(`Error getting voting power...\n${error}`);
        return false;
    }
}
exports.hasPACTVotingPower = hasPACTVotingPower;
async function getPACTTVL(provider, chainId) {
    // if not on mainnet
    if (chainId !== 42220) {
        return '--';
    }
    const contractAddresses = contractAddress_1.ContractAddresses.get(chainId);
    const { PACTToken, PACTDelegator } = contractAddresses;
    try {
        const result = await client.query({
            query: (0, client_1.gql) `
                {
                    tokenDayDatas(
                        first:1
                        orderBy: date
                        orderDirection: desc
                        where: {token: "${PACTToken.toLowerCase()}"}
                    ) {
                        priceUSD
                    }
                }
                `
        });
        const pact = new contracts_1.Contract(PACTToken, BaseERC20_json_1.default, provider);
        const TVL = (0, toNumber_1.toNumber)((await pact.balanceOf(PACTDelegator)).toString()) *
            parseFloat(result.data.tokenDayDatas[0].priceUSD);
        return TVL.toString();
    }
    catch (_) {
        return '--';
    }
}
exports.getPACTTVL = getPACTTVL;
async function getUBILiquidity(provider, chainId) {
    const contractAddresses = contractAddress_1.ContractAddresses.get(chainId);
    const { cUSD, Treasury } = contractAddresses;
    const cusd = new contracts_1.Contract(cUSD, BaseERC20_json_1.default, provider);
    return (0, toNumber_1.toNumber)((await cusd.balanceOf(Treasury)).toString());
}
exports.getUBILiquidity = getUBILiquidity;
//# sourceMappingURL=pact.js.map